<template>
  <svg class="zhitu-icon" aria-hidden="true" :style="{
    color: color
  }">
    <use :xlink:href="`#${icon}`"></use>
  </svg>
</template>
<script>
export default {
  name: 'ZhituIcon',
  props: {
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.zhitu-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  color: #525C6F;
}
</style>